import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

/* ─── Intel Panel (hero right) ─── */
const IntelPanel = () => (
  <div className="intel-panel">
    <div className="intel-header">
      <span className="intel-title">Integration topology · live</span>
      <div className="intel-live"><div className="live-dot" />Live</div>
    </div>
    <div className="map-preview">
      <svg className="edge-svg" viewBox="0 0 320 180" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
        <line x1="60" y1="60" x2="130" y2="60" stroke="rgba(10,191,163,0.4)" strokeWidth="1" strokeDasharray="4 2" className="edge-animated" />
        <line x1="60" y1="60" x2="100" y2="120" stroke="rgba(10,191,163,0.25)" strokeWidth="1" />
        <line x1="190" y1="60" x2="260" y2="60" stroke="rgba(127,119,221,0.5)" strokeWidth="1.5" strokeDasharray="4 2" className="edge-animated" />
        <line x1="190" y1="60" x2="200" y2="120" stroke="rgba(10,191,163,0.25)" strokeWidth="1" />
        <line x1="130" y1="60" x2="190" y2="60" stroke="rgba(10,191,163,0.4)" strokeWidth="1" strokeDasharray="4 2" className="edge-animated" />
        <circle cx="190" cy="62" r="3" fill="rgba(127,119,221,0.8)" />
      </svg>
      <div className="map-node" style={{ left: 30, top: 35 }}>
        <div style={{ position: 'relative' }}>
          <div className="critical-badge">CRITICAL PATH</div>
          <div className="node-circle" style={{ color: 'var(--gold)', borderColor: 'var(--gold)', background: 'var(--goldl)' }}>STR</div>
        </div>
        <div className="node-label" style={{ color: 'var(--gold)' }}>Stripe</div>
        <div className="node-health" style={{ color: 'var(--green)' }}>&#9679; 99.1%</div>
      </div>
      <div className="map-node" style={{ left: 115, top: 35 }}>
        <div className="node-circle" style={{ color: 'var(--cyan)', borderColor: 'var(--cyan)', background: 'var(--cyanl)' }}>SF</div>
        <div className="node-label" style={{ color: 'var(--silv)' }}>Salesforce</div>
        <div className="node-health" style={{ color: 'var(--green)' }}>&#9679; 98.4%</div>
      </div>
      <div className="map-node" style={{ left: 170, top: 35 }}>
        <div style={{ position: 'relative' }}>
          <div className="critical-badge">CRITICAL PATH</div>
          <div className="node-circle" style={{ color: 'var(--gold)', borderColor: 'var(--gold)', background: 'var(--goldl)' }}>SLK</div>
        </div>
        <div className="node-label" style={{ color: 'var(--gold)' }}>Slack</div>
        <div className="node-health" style={{ color: 'var(--amber)' }}>&#9650; Drift</div>
      </div>
      <div className="map-node" style={{ left: 240, top: 35 }}>
        <div className="node-circle" style={{ color: 'var(--purple)', borderColor: 'var(--purple)', background: 'var(--purpl)' }}>GH</div>
        <div className="node-label" style={{ color: 'var(--silv)' }}>GitHub</div>
        <div className="node-health" style={{ color: 'var(--green)' }}>&#9679; 100%</div>
      </div>
      <div className="map-node" style={{ left: 72, top: 100 }}>
        <div className="node-circle" style={{ color: 'var(--silv)', borderColor: 'var(--slate)' }}>PG</div>
        <div className="node-label" style={{ color: 'var(--slate)' }}>Postgres</div>
        <div className="node-health" style={{ color: 'var(--green)' }}>&#9679; 100%</div>
      </div>
      <div className="map-node" style={{ left: 175, top: 100 }}>
        <div className="node-circle" style={{ color: 'var(--silv)', borderColor: 'var(--slate)' }}>HS</div>
        <div className="node-label" style={{ color: 'var(--slate)' }}>HubSpot</div>
        <div className="node-health" style={{ color: 'var(--red)' }}>&#10005; Error</div>
      </div>
    </div>
    <div className="query-bar">
      <input className="query-input" type="text" placeholder="What depends on Slack?  Ask anything..." readOnly />
      <div className="query-run">Run &rarr;</div>
    </div>
    <div className="change-feed">
      <div className="change-row">
        <div className="ch-sev" style={{ background: 'var(--red)' }} />
        <div className="ch-time">2m ago</div>
        <div className="ch-text">HubSpot schema drift — 3 fields removed</div>
        <div className="ch-badge" style={{ color: 'var(--red)', borderColor: 'rgba(226,75,74,.3)' }}>Critical</div>
      </div>
      <div className="change-row">
        <div className="ch-sev" style={{ background: 'var(--amber)' }} />
        <div className="ch-time">14m</div>
        <div className="ch-text">Slack webhook volume anomaly detected</div>
        <div className="ch-badge" style={{ color: 'var(--amber)', borderColor: 'rgba(239,159,39,.3)' }}>Warning</div>
      </div>
      <div className="change-row">
        <div className="ch-sev" style={{ background: 'var(--green)' }} />
        <div className="ch-time">1h</div>
        <div className="ch-text">Stripe &rarr; Salesforce sync recovered</div>
        <div className="ch-badge" style={{ color: 'var(--green)', borderColor: 'rgba(29,158,117,.3)' }}>Resolved</div>
      </div>
    </div>
    <div className="stat-strip">
      <div className="stat-cell"><div className="sc-val">24</div><div className="sc-lbl">Connections</div></div>
      <div className="stat-cell"><div className="sc-val" style={{ color: 'var(--gold)' }}>3</div><div className="sc-lbl">Critical path</div></div>
      <div className="stat-cell"><div className="sc-val" style={{ color: 'var(--amber)' }}>2</div><div className="sc-lbl">Anomalies</div></div>
      <div className="stat-cell"><div className="sc-val">99.1%</div><div className="sc-lbl">Uptime</div></div>
    </div>
  </div>
);

/* ─── Mapper Canvas ─── */
const MapperCanvas = () => (
  <div className="mapper-canvas">
    <div className="canvas-header">
      <span className="canvas-title">Integration topology · production</span>
      <div className="canvas-tools">
        <div className="tool-btn active">Force</div>
        <div className="tool-btn">Hierarchy</div>
        <div className="tool-btn">Circular</div>
        <div className="tool-btn">Manual</div>
        <div className="tool-btn">Export &#8599;</div>
      </div>
    </div>
    <div className="canvas-body">
      <svg className="edge-svg" viewBox="0 0 440 260" style={{ position: 'absolute', inset: 0, width: 'calc(100% - 160px)', height: '100%' }}>
        <line x1="80" y1="60" x2="180" y2="60" stroke="rgba(10,191,163,0.5)" strokeWidth="1.5" strokeDasharray="5 3" className="edge-animated" />
        <line x1="80" y1="60" x2="100" y2="150" stroke="rgba(10,191,163,0.3)" strokeWidth="1" />
        <line x1="180" y1="60" x2="280" y2="60" stroke="rgba(200,160,48,0.6)" strokeWidth="2" strokeDasharray="5 3" className="edge-animated" />
        <line x1="280" y1="60" x2="360" y2="60" stroke="rgba(127,119,221,0.5)" strokeWidth="1.5" strokeDasharray="5 3" className="edge-animated" />
        <line x1="180" y1="60" x2="200" y2="150" stroke="rgba(10,191,163,0.3)" strokeWidth="1" />
        <line x1="280" y1="60" x2="300" y2="150" stroke="rgba(10,191,163,0.25)" strokeWidth="1" />
        <circle cx="180" cy="62" r="4" fill="rgba(127,119,221,0.9)" />
        <circle cx="280" cy="62" r="4" fill="rgba(127,119,221,0.9)" />
      </svg>
      <div className="mn" style={{ left: 52, top: 32 }}>
        <div style={{ position: 'relative' }}>
          <div className="cp-badge">CRITICAL</div>
          <div className="mn-circle" style={{ color: 'var(--gold)', borderColor: 'var(--gold)', background: 'var(--goldl)' }}>STR</div>
        </div>
        <div className="mn-label" style={{ color: 'var(--gold)' }}>Stripe</div>
        <div className="mn-health" style={{ color: 'var(--green)' }}>&#9679; Healthy</div>
      </div>
      <div className="mn" style={{ left: 157, top: 32 }}>
        <div className="mn-circle" style={{ color: 'var(--cyan)', borderColor: 'var(--cyan)', background: 'var(--cyanl)' }}>SF</div>
        <div className="mn-label" style={{ color: 'var(--silv)' }}>Salesforce</div>
        <div className="mn-health" style={{ color: 'var(--green)' }}>&#9679; Healthy</div>
      </div>
      <div className="mn" style={{ left: 255, top: 32 }}>
        <div style={{ position: 'relative' }}>
          <div className="cp-badge">CRITICAL</div>
          <div className="mn-circle" style={{ color: 'var(--gold)', borderColor: 'var(--gold)', background: 'var(--goldl)' }}>SLK</div>
        </div>
        <div className="mn-label" style={{ color: 'var(--gold)' }}>Slack</div>
        <div className="mn-health" style={{ color: 'var(--amber)' }}>&#9650; Drift</div>
      </div>
      <div className="mn" style={{ left: 340, top: 32 }}>
        <div className="mn-circle" style={{ color: 'var(--purple)', borderColor: 'var(--purple)', background: 'var(--purpl)' }}>GH</div>
        <div className="mn-label" style={{ color: 'var(--silv)' }}>GitHub</div>
        <div className="mn-health" style={{ color: 'var(--green)' }}>&#9679; Healthy</div>
      </div>
      <div className="mn" style={{ left: 72, top: 128 }}>
        <div className="mn-circle" style={{ color: 'var(--silv)', borderColor: 'var(--slate)' }}>PG</div>
        <div className="mn-label" style={{ color: 'var(--slate)' }}>Postgres</div>
        <div className="mn-health" style={{ color: 'var(--green)' }}>&#9679; Healthy</div>
      </div>
      <div className="mn" style={{ left: 176, top: 128 }}>
        <div className="mn-circle" style={{ color: 'var(--red)', borderColor: 'var(--red)', background: 'rgba(226,75,74,.1)' }}>HS</div>
        <div className="mn-label" style={{ color: 'var(--red)' }}>HubSpot</div>
        <div className="mn-health" style={{ color: 'var(--red)' }}>&#10005; Error</div>
      </div>
      <div className="change-panel">
        <div className="cp-title">Change history</div>
        <div className="cp-event"><div className="cpe-time">2m ago</div><div className="cpe-text cpe-red">HubSpot: 3 fields removed from /contacts</div></div>
        <div className="cp-event"><div className="cpe-time">14m</div><div className="cpe-text cpe-amber">Slack: webhook volume +340% anomaly</div></div>
        <div className="cp-event"><div className="cpe-time">1h</div><div className="cpe-text cpe-green">Stripe sync recovered after retry</div></div>
        <div className="cp-event"><div className="cpe-time">3h</div><div className="cpe-text cpe-cyan">GitHub edge enriched with field_mappings</div></div>
        <div className="cp-event"><div className="cpe-time">6h</div><div className="cpe-text cpe-amber">Salesforce: new required field detected</div></div>
      </div>
    </div>
  </div>
);

/* ═══════════════════════════════════════
   LANDING PAGE v3 — Faithful to source HTML
   ═══════════════════════════════════════ */
export default function LandingPage() {
  const navigate = useNavigate();
  const handleGetStarted = () => navigate('/login');

  return (
    <div className="lp-root" data-testid="landing-page">
      <div className="ambient amb1" />
      <div className="ambient amb2" />

      {/* ─── NAV ─── */}
      <nav className="lp-nav" data-testid="landing-nav">
        <div className="nav-logo">
          <span className="nav-wordmark">KO<span>VA</span></span>
          <span className="nav-badge">Hub</span>
        </div>
        <div className="nav-links">
          <a href="#platform">Platform</a>
          <a href="#build">Build</a>
          <a href="#mapper">Map</a>
          <a href="#query">Query</a>
          <a href="#retention">Reporting</a>
          <a href="#matr">MATR</a>
          <a href="#features">Features</a>
        </div>
        <button className="nav-cta" onClick={handleGetStarted} data-testid="nav-get-started-btn">Start free &rarr;</button>
      </nav>

      {/* ─── HERO ─── */}
      <section className="lp-hero" data-testid="landing-hero">
        <div className="hero-left">
          <div className="hero-kicker">API Intelligence Hub · kovahub.co</div>
          <h1 className="hero-h1">
            Every system.<br />
            <span className="hl">Mapped.</span><br />
            <span className="hl">Queried.</span><br />
            <span className="dim">Understood.</span>
          </h1>
          <p className="hero-sub">
            KOVA connects your APIs, maps your entire integration environment, detects <strong>critical path failures before they happen</strong>, and lets anyone query across all connected systems in plain English.
          </p>
          <div className="hero-pills">
            <span className="pill active">Environment Mapper</span>
            <span className="pill active">NL Query Engine</span>
            <span className="pill active">Anomaly Detection</span>
            <span className="pill">Data Lineage</span>
            <span className="pill">Change History</span>
            <span className="pill">Retention &amp; Reporting API</span>
          </div>
          <div className="hero-actions">
            <button className="btn-primary" onClick={handleGetStarted} data-testid="hero-get-started-btn">Connect your first API &rarr;</button>
            <button className="btn-ghost">See the map demo</button>
          </div>
        </div>
        <div className="hero-right">
          <IntelPanel />
        </div>
      </section>

      {/* ─── THREE PILLARS ─── */}
      <section className="lp-pillars" id="platform" data-testid="landing-pillars">
        <div className="pillars-eyebrow">The platform</div>
        <h2 className="pillars-title">Not just integration.<br /><em>Intelligence.</em></h2>
        <p className="pillars-sub">KOVA operates in three layers that compound in value. Connect once and unlock the full intelligence stack — from topology mapping to anomaly detection to cross-system queries in plain English.</p>
        <div className="pillar-grid">
          <div className="pillar">
            <div className="pillar-bg-num">1</div>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div className="pillar-num">Layer 01 · Foundation</div>
              <div className="pillar-name">Integration Intelligence</div>
              <div className="pillar-desc">Connect your APIs once. KOVA manages authentication, scheduling, transforms, webhooks, and notifications across every system you touch.</div>
              <div className="pillar-features">
                <div className="pf">API templates — Stripe, Slack, GitHub, and more</div>
                <div className="pf">Cron-based scheduler with retry and dependencies</div>
                <div className="pf">Visual data transform rule builder</div>
                <div className="pf">Email + Slack push notifications via Block Kit</div>
                <div className="pf">Schema monitoring — detect drift before it breaks</div>
              </div>
            </div>
          </div>
          <div className="pillar gold-accent">
            <div className="pillar-bg-num" style={{ color: 'rgba(200,160,48,0.04)' }}>2</div>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div className="pillar-num" style={{ color: 'var(--gold)' }}>Layer 02 · Intelligence</div>
              <div className="pillar-name">Environment Mapper</div>
              <div className="pillar-desc">Auto-derived topology graph of your entire integration environment. See every system, every connection, every data flow — live. Know what will break before it does.</div>
              <div className="pillar-features">
                <div className="pf">PageRank-style critical path scoring</div>
                <div className="pf">BFS downstream impact analysis</div>
                <div className="pf">Data lineage — field mappings on every edge</div>
                <div className="pf">Change history with acknowledge flow</div>
                <div className="pf">4 layout modes + shareable read-only links</div>
              </div>
            </div>
          </div>
          <div className="pillar purple-accent">
            <div className="pillar-bg-num" style={{ color: 'rgba(127,119,221,0.04)' }}>3</div>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div className="pillar-num" style={{ color: 'var(--purple)' }}>Layer 03 · Query</div>
              <div className="pillar-name">Cross-System Query Engine</div>
              <div className="pillar-desc">Ask questions across all connected systems in plain English. KOVA routes to the right model, generates the execution plan, and returns structured results — no SQL, no SDK, no developer.</div>
              <div className="pillar-features">
                <div className="pf">Multi-LLM routing — Claude, GPT, Gemini</div>
                <div className="pf">Plan &rarr; confirm &rarr; execute safety model</div>
                <div className="pf">Cross-system pair suggestions from MATR</div>
                <div className="pf">NL map queries — highlight results on topology</div>
                <div className="pf">Live and historical query against retained data</div>
                <div className="pf">Reporting API — Tableau, Power BI, Databricks connect directly</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── NL BUILD ─── */}
      <section className="nl-build-section" id="build" data-testid="landing-nl-build">
        <div className="nl-build-inner">
          <div>
            <div className="pillars-eyebrow" style={{ marginBottom: 20 }}>Natural language interface</div>
            <h2 className="pillars-title" style={{ fontSize: 'clamp(24px,3vw,44px)', marginBottom: 16 }}>Describe it.<br />KOVA <em>builds it.</em></h2>
            <p style={{ fontSize: 14, color: 'var(--silv)', lineHeight: 1.8, marginBottom: 24 }}>You do not need to know what an API endpoint is. Type what you want to connect in plain English. KOVA's multi-LLM routing engine selects the right model, generates the integration configuration, maps the fields automatically, and deploys on your confirmation. No JSON. No tickets. No waiting.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--cyan)', fontSize: 11, marginTop: 2, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Plan &rarr; confirm &rarr; deploy</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>KOVA always shows you the integration plan before executing. Review every step, field mapping, and action. Deploy when you are satisfied. You are always in control.</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--purple)', fontSize: 11, marginTop: 2, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Multi-LLM routing — automatic</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>Claude Sonnet 4.6, GPT, and Gemini are all available. KOVA routes to the optimal model for each task type. You never have to choose — or even know which model ran.</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--gold)', fontSize: 11, marginTop: 2, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Field mappings generated automatically</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>KOVA reads the schema of both systems and generates the field mapping between them. The same mappings then appear as data lineage on the Environment Mapper — no duplicate work.</div>
                </div>
              </div>
            </div>
            <div style={{ fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--slate)', marginBottom: 8 }}>Try saying</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 10, color: 'var(--silv)', padding: '7px 10px', background: 'var(--card)', border: '1px solid var(--bord)', borderLeft: '2px solid var(--cyan)' }}>"When a Stripe payment succeeds, update the student in Uday and post to Slack"</div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 10, color: 'var(--silv)', padding: '7px 10px', background: 'var(--card)', border: '1px solid var(--bord)', borderLeft: '2px solid var(--purple)' }}>"Sync new GitHub PRs merged to main into a Notion database every hour"</div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 10, color: 'var(--silv)', padding: '7px 10px', background: 'var(--card)', border: '1px solid var(--bord)', borderLeft: '2px solid var(--gold)' }}>"Alert #ops-alerts when any monitored API returns errors for more than 5 minutes"</div>
            </div>
          </div>
          <div className="nl-demo">
            <div className="nl-demo-bar">
              <span className="nl-demo-title">KOVA · Natural Language Build</span>
              <span className="nl-badge">Auto · Claude Sonnet 4.6</span>
            </div>
            <div className="nl-input-area">
              <div className="nl-input-label">What do you want to connect?</div>
              <textarea className="nl-input" rows="2" readOnly defaultValue="When a Stripe payment succeeds, update the student record in Uday and post a summary to Slack #finance-alerts" />
              <div className="nl-submit"><button className="nl-btn">Generate Integration &rarr;</button></div>
            </div>
            <div className="nl-output">
              <div className="nl-output-label">Integration plan — review and confirm to deploy</div>
              <div className="nl-step">
                <div className="nl-step-num">1</div>
                <div className="nl-step-body">
                  <div className="nl-step-title">Trigger — Stripe payment.succeeded webhook</div>
                  <div className="nl-step-desc">Listening on your Stripe webhook endpoint. Fires when a payment intent succeeds. Auth: Bearer token via existing Stripe connection.</div>
                </div>
              </div>
              <div className="nl-step">
                <div className="nl-step-num">2</div>
                <div className="nl-step-body">
                  <div className="nl-step-title">Transform — Map Stripe event to Uday student record</div>
                  <div className="nl-step-desc">Field mapping generated automatically:</div>
                  <div className="nl-mapping-preview">
                    <div className="nl-mapping-row"><span className="nl-field">stripe.customer.email</span><span className="nl-arrow">&rarr;</span><span className="nl-field-out">uday.student.email</span></div>
                    <div className="nl-mapping-row"><span className="nl-field">stripe.amount</span><span className="nl-arrow">&rarr;</span><span className="nl-field-out">uday.payment.amount_cents</span></div>
                    <div className="nl-mapping-row"><span className="nl-field">stripe.metadata.student_id</span><span className="nl-arrow">&rarr;</span><span className="nl-field-out">uday.student.id</span></div>
                  </div>
                </div>
              </div>
              <div className="nl-step">
                <div className="nl-step-num">3</div>
                <div className="nl-step-body">
                  <div className="nl-step-title">{'Action — POST to Uday /students/{id}/payments'}</div>
                  <div className="nl-step-desc">Updates the student enrollment record. Retry: 3&#215; with exponential backoff. On failure: alert via push notification to configured channels.</div>
                </div>
              </div>
              <div className="nl-step">
                <div className="nl-step-num">4</div>
                <div className="nl-step-body">
                  <div className="nl-step-title">Notify — Post summary to Slack #finance-alerts</div>
                  <div className="nl-step-desc">Formatted Block Kit message: student name, amount, timestamp, enrollment status. Routes via existing Slack webhook connection.</div>
                </div>
              </div>
              <div className="nl-confirm">
                <button className="nl-confirm-btn">Deploy Integration &#10003;</button>
                <button className="nl-cancel">Edit</button>
                <button className="nl-cancel">Discard</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── ENVIRONMENT MAPPER ─── */}
      <section className="mapper-section" id="mapper" data-testid="landing-mapper">
        <div className="mapper-inner">
          <div className="mapper-left">
            <MapperCanvas />
          </div>
          <div className="mapper-right">
            <div className="mapper-tag">Environment Mapper</div>
            <h2 className="pillars-title" style={{ fontSize: 'clamp(24px,3vw,40px)' }}>Your integration<br />environment.<br /><em>Finally visible.</em></h2>
            <p style={{ fontSize: 14, color: 'var(--silv)', lineHeight: 1.8, marginBottom: 4 }}>KOVA auto-derives the topology of every connected system. No manual diagramming. No stale architecture docs. The map updates itself every time a connection changes, a job runs, or a schema drifts.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--gold)', fontSize: 12, marginTop: 1, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Critical path scoring</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>PageRank-style algorithm scores every node by downstream dependency weight. Top 3 critical path nodes highlighted in gold. Know what to protect before something breaks.</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--purple)', fontSize: 12, marginTop: 1, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Data lineage on every edge</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>Click any edge to see source fields, destination fields, volume, error rate, and transform rules applied. Full data lineage — automatically derived from your field mappings.</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--cyan)', fontSize: 12, marginTop: 1, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>BFS impact analysis</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>Click any node and instantly see every downstream system that depends on it — in plain English. "If HubSpot goes down, these 4 systems are affected." That sentence used to require an architect. Now it takes one click.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── QUERY ENGINE ─── */}
      <section className="query-section" id="query" data-testid="landing-query">
        <div className="query-inner">
          <div>
            <div className="pillars-eyebrow" style={{ marginBottom: 20 }}>Cross-system query engine</div>
            <h2 className="pillars-title" style={{ fontSize: 'clamp(24px,3vw,44px)', marginBottom: 16 }}>Ask anything.<br /><em>Across everything.</em></h2>
            <p style={{ fontSize: 14, color: 'var(--silv)', lineHeight: 1.8, marginBottom: 28 }}>KOVA's query engine lets anyone ask questions that span multiple connected systems — in plain English. No SQL. No SDK. No developer ticket. The engine generates a plan, shows you what it will do, and executes on confirm.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--silv)', marginBottom: 4 }}>Try these</div>
              <div className="suggestion-row">
                <div className="sug-chip cross">Stripe + Salesforce revenue gap</div>
                <div className="sug-chip cross">GitHub + Slack deploy notifications</div>
                <div className="sug-chip">Failed payments last 7 days</div>
                <div className="sug-chip">What depends on HubSpot?</div>
                <div className="sug-chip cross">Contacts without deals &rarr; Salesforce</div>
              </div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 8, color: 'var(--slate)', marginTop: 4 }}>&#9672; Cross-system pair — MATR intelligence highlighted</div>
            </div>
          </div>
          <div className="query-terminal">
            <div className="qt-header">
              <div className="qt-dot" style={{ color: 'var(--red)', borderColor: 'var(--red)' }} />
              <div className="qt-dot" style={{ color: 'var(--amber)', borderColor: 'var(--amber)' }} />
              <div className="qt-dot" style={{ color: 'var(--green)', borderColor: 'var(--green)' }} />
              <span className="qt-title">KOVA Query Engine</span>
            </div>
            <div className="qt-body">
              <div className="qt-line"><span className="qt-prompt">&#9656;</span> <span className="qt-user">Show me Stripe customers who haven't been synced to Salesforce</span></div>
              <hr className="qt-divider" />
              <div className="qt-line qt-result">&#9672; Routing to: Claude Sonnet 4.6</div>
              <div className="qt-line qt-result">&#9672; Sources: Stripe /customers, Salesforce /contacts</div>
              <div className="qt-line qt-result">&#9672; Join key: email &rarr; email</div>
              <div className="qt-line qt-result">&#9672; Filter: present in Stripe, absent in Salesforce</div>
              <hr className="qt-divider" />
              <div className="qt-line"><span className="qt-prompt">?</span> <span style={{ color: 'var(--amber)' }}>Execute this plan across 2 live systems? [confirm/cancel]</span></div>
              <div className="qt-line"><span className="qt-prompt">&#9656;</span> <span className="qt-user">confirm</span></div>
              <hr className="qt-divider" />
              <div className="qt-line"><span className="qt-value">&#10003; 47 customers found</span></div>
              <div className="qt-line qt-result">Most recent: j.chen@acme.co ($2,400/mo)</div>
              <div className="qt-line qt-result">Oldest gap: 23 days · m.rivera@startup.io ($890/mo)</div>
              <div className="qt-line qt-warn">&#9888; 3 customers have failed payments — prioritize sync</div>
              <hr className="qt-divider" />
              <div className="qt-line"><span className="qt-prompt">&#9656;</span> <span className="qt-cursor" /></div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── RETENTION & REPORTING ─── */}
      <section className="retention-section" id="retention" data-testid="landing-retention">
        <div className="retention-inner">
          <div>
            <div className="pillars-eyebrow" style={{ marginBottom: 20 }}>Data retention &amp; reporting</div>
            <h2 className="pillars-title" style={{ fontSize: 'clamp(24px,3vw,44px)', marginBottom: 16 }}>KOVA becomes<br />your <em>data platform.</em></h2>
            <p style={{ fontSize: 14, color: 'var(--silv)', lineHeight: 1.8, marginBottom: 20 }}>A configurable retention layer and a Reporting API let external BI tools connect to KOVA as a live data source. Snowflake, Databricks, Tableau, Power BI, and Looker query your integration history directly — no data migration, no ETL pipeline, no warehouse required to get started.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--cyan)', fontSize: 11, marginTop: 2, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Live + historical queries</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>The query engine routes against live data in real time. The retained data store adds historical depth — ask "what was the state of this data last quarter?" without touching the source system.</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--purple)', fontSize: 11, marginTop: 2, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Reporting API for BI tools</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>A REST Reporting API with scoped reporting tokens lets Tableau, Power BI, and Looker connect to KOVA directly. KOVA becomes their data source — spanning every connected system, live and historical.</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'start', gap: 12, padding: 12, background: 'var(--card)', border: '1px solid var(--bord)' }}>
                <div style={{ color: 'var(--gold)', fontSize: 11, marginTop: 2, flexShrink: 0 }}>&#9670;</div>
                <div>
                  <div style={{ fontFamily: 'var(--syne)', fontSize: 12, fontWeight: 700, color: 'var(--white)', marginBottom: 3 }}>Databricks &amp; Snowflake ingestion</div>
                  <div style={{ fontSize: 11, color: 'var(--silv)', lineHeight: 1.5 }}>Databricks Lakeflow Connect and Snowflake external tables ingest from KOVA's streaming NDJSON export endpoint. KOVA handles live operational queries. Databricks handles complex ML workloads on KOVA's retained history.</div>
                </div>
              </div>
            </div>
            <div style={{ fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--slate)', marginBottom: 6 }}>Connects to</div>
            <div className="bi-logos">
              <span className="bi-pill lit">Databricks</span>
              <span className="bi-pill lit">Snowflake</span>
              <span className="bi-pill lit">Tableau</span>
              <span className="bi-pill lit">Power BI</span>
              <span className="bi-pill lit">Looker</span>
              <span className="bi-pill">Custom BI</span>
              <span className="bi-pill">Internal tools</span>
            </div>
            <div className="ret-callout">
              <div className="ret-callout-label">The difference vs Snowflake</div>
              <div className="ret-callout-text">Snowflake: migrate your data in first, query what landed there. KOVA: your data stays where it lives, query it live or from the retention store. No migration. No ETL. No warehouse bill to get started. Snowflake can connect to KOVA as a downstream consumer — not the other way around.</div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="query-terminal">
              <div className="qt-header">
                <div className="qt-dot" style={{ color: 'var(--red)', borderColor: 'var(--red)' }} />
                <div className="qt-dot" style={{ color: 'var(--amber)', borderColor: 'var(--amber)' }} />
                <div className="qt-dot" style={{ color: 'var(--green)', borderColor: 'var(--green)' }} />
                <span className="qt-title">Reporting API · Overview</span>
              </div>
              <div className="qt-body">
                <div className="qt-line qt-result">&#9672; Query integration events, job history, and query results</div>
                <div className="qt-line qt-result">&#9672; Filter by connection, time range, record type, and outcome</div>
                <div className="qt-line qt-result">&#9672; Aggregate by any dimension — count, sum, or average</div>
                <div className="qt-line qt-result">&#9672; Stream export directly to Databricks and Snowflake</div>
                <hr className="qt-divider" />
                <div className="qt-line qt-result">&#9672; Scoped reporting tokens — separate from session auth</div>
                <div className="qt-line qt-result">&#9672; Cursor-based pagination for large datasets</div>
                <div className="qt-line qt-result">&#9672; Schema discovery endpoint — BI tools auto-configure</div>
                <hr className="qt-divider" />
                <div className="qt-line" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
                  <span className="qt-result" style={{ fontSize: 10 }}>Full API reference available after signup</span>
                  <button style={{ background: 'var(--cyanl)', border: '1px solid var(--cyan)', color: 'var(--cyan)', fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: 1.5, textTransform: 'uppercase', padding: '6px 14px', cursor: 'crosshair', transition: 'all .2s' }}>View API Docs &rarr;</button>
                </div>
              </div>
            </div>
            <div>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--slate)', marginBottom: 2 }}>Storage tiers by plan</div>
              <div className="tier-table">
                <div className="tier-row t-header">
                  <div className="tier-cell tc-head">Plan</div>
                  <div className="tier-cell tc-head">Retention</div>
                  <div className="tier-cell tc-head">Storage</div>
                  <div className="tier-cell tc-head">Exports</div>
                </div>
                <div className="tier-row"><div className="tier-cell tc-name">Free</div><div className="tier-cell tc-val">None</div><div className="tier-cell tc-val">—</div><div className="tier-cell tc-val">—</div></div>
                <div className="tier-row"><div className="tier-cell tc-name">Starter</div><div className="tier-cell tc-val">30 days</div><div className="tier-cell tc-val">1 GB</div><div className="tier-cell tc-val">5/day</div></div>
                <div className="tier-row"><div className="tier-cell tc-name">Growth</div><div className="tier-cell tc-val">90 days</div><div className="tier-cell tc-val">10 GB</div><div className="tier-cell tc-val">50/day</div></div>
                <div className="tier-row" style={{ background: 'var(--cyanl)' }}>
                  <div className="tier-cell tc-name" style={{ color: 'var(--cyan)' }}>Enterprise</div>
                  <div className="tier-cell" style={{ color: 'var(--cyan)' }}>Unlimited</div>
                  <div className="tier-cell" style={{ color: 'var(--cyan)' }}>Unlimited</div>
                  <div className="tier-cell" style={{ color: 'var(--cyan)' }}>Unlimited</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── MATR ─── */}
      <section className="matr-section" id="matr" data-testid="landing-matr">
        <div className="matr-bg">MATR</div>
        <div className="matr-inner">
          <div className="matr-left">
            <div className="matr-tag">&#9672; MATR Intelligence Layer</div>
            <h2 className="pillars-title" style={{ fontSize: 'clamp(24px,3vw,44px)', marginBottom: 16 }}>Every query.<br />Every connection.<br /><em>Gets smarter.</em></h2>
            <p style={{ fontSize: 14, color: 'var(--silv)', lineHeight: 1.8, marginBottom: 28 }}>MATR is the intelligence layer running beneath KOVA. It learns from every integration event, query pattern, and topology change across your environment — then surfaces anomalies, suggests cross-system queries, and feeds the MERA Human Intelligence Layer.</p>
            <div className="matr-cards">
              <div className="matr-card"><div className="mc-val">&#9672;</div><div className="mc-lbl">Anomaly detection</div><div className="mc-desc">Volume drops, pattern breaks, schema drift spikes — detected automatically on 7-day rolling baselines.</div></div>
              <div className="matr-card"><div className="mc-val">&infin;</div><div className="mc-lbl">Compounding intelligence</div><div className="mc-desc">Every workspace teaches MATR. Cross-system query suggestions improve with every interaction.</div></div>
              <div className="matr-card"><div className="mc-val">4</div><div className="mc-lbl">Anomaly types</div><div className="mc-desc">Volume, pattern breaks, cross-feature correlation, and suggestion intent shifts — all detected automatically.</div></div>
              <div className="matr-card"><div className="mc-val">30s</div><div className="mc-lbl">Dashboard refresh</div><div className="mc-desc">The MATR Analytics Dashboard refreshes every 30 seconds. Live event flow, heatmaps, and adoption metrics.</div></div>
            </div>
          </div>
          <div>
            <div className="anomaly-feed">
              <div className="af-header">
                <span className="af-title">&#9672; MATR · Anomaly feed</span>
                <span className="af-count">2 active</span>
              </div>
              <div className="af-row">
                <div className="af-sev" style={{ background: 'var(--red)' }} />
                <div className="af-content">
                  <div className="af-name">Volume anomaly — Slack webhooks</div>
                  <div className="af-desc">Webhook volume is 340% above 7-day baseline. Cross-feature correlation with GitHub edge spike suggests a deploy event cascade. Not a normal pattern.</div>
                </div>
                <div className="af-time">14m ago</div>
              </div>
              <div className="af-row">
                <div className="af-sev" style={{ background: 'var(--amber)' }} />
                <div className="af-content">
                  <div className="af-name">Schema drift spike — HubSpot</div>
                  <div className="af-desc">HubSpot /contacts response schema changed 3 times in 6 hours. 7-day average is 0.2 changes/day. Three downstream transforms may break on next execution.</div>
                </div>
                <div className="af-time">2h ago</div>
              </div>
              <div className="af-row">
                <div className="af-sev" style={{ background: 'var(--green)' }} />
                <div className="af-content">
                  <div className="af-name">Pattern resolved — Stripe sync</div>
                  <div className="af-desc">Stripe &rarr; Salesforce sync returned to baseline after 47-minute degradation. Root cause: Stripe API rate limit during billing cycle. Auto-retry resolved.</div>
                </div>
                <div className="af-time">1h ago</div>
              </div>
              <div className="af-row">
                <div className="af-sev" style={{ background: 'var(--cyan)' }} />
                <div className="af-content">
                  <div className="af-name">New cross-system suggestion</div>
                  <div className="af-desc">MATR detected a new high-value query pattern: GitHub PR merge &rarr; Salesforce opportunity stage update. No automation exists yet. Suggested via query bar.</div>
                </div>
                <div className="af-time">3h ago</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── FEATURES ─── */}
      <section className="lp-features" id="features" data-testid="landing-features">
        <div className="pillars-eyebrow">All capabilities</div>
        <h2 className="pillars-title" style={{ maxWidth: 500 }}>The complete<br /><em>intelligence stack.</em></h2>
        <div className="feat-grid">
          {[
            { icon: '\u2B21', name: 'API Connections', desc: 'Full CRUD management for REST APIs. Bearer token, API key, OAuth2. Production-ready connection health monitoring across every system.', status: 'Live', cls: 'live' },
            { icon: '\u25F7', name: 'Smart Scheduler', desc: 'Cron-based job scheduling with retry logic, job dependencies, and full execution history. Build integration pipelines without touching infrastructure.', status: 'Live', cls: 'live' },
            { icon: '\u25B3', name: 'Push Notifications', desc: 'Email and Slack Block Kit alerts for failures, retry exhaustion, and threshold breaches. Alerts go where your team lives — not buried in a dashboard.', status: 'Live', cls: 'live' },
            { icon: '\u21C6', name: 'Data Transforms', desc: 'Visual rule builder for field mapping, type coercion, and conditional routing. Transform rules auto-enrich edge intelligence on the topology map.', status: 'Live', cls: 'live' },
            { icon: '\u27C6', name: 'NL Interface', desc: 'Describe any integration in plain English. Multi-LLM routing selects Claude, GPT, or Gemini automatically. KOVA generates the config and deploys on confirm.', status: 'Live', cls: 'live' },
            { icon: '\u229D', name: 'Schema Monitoring', desc: "API response diff engine that detects upstream schema changes before they break your pipelines. Silent drift ends here. Drift events visible on the topology map.", status: 'Live', cls: 'live' },
            { icon: '\u25C9', name: 'Cross-System Queries', desc: 'Plain English queries across all connected systems simultaneously. Plan → confirm → execute safety model. Results in seconds, no SQL or SDK required.', status: 'New', cls: 'purple', borderColor: 'rgba(127,119,221,.3)' },
            { icon: '\u25CE', name: 'Environment Mapper', desc: 'Auto-derived topology of your integration environment. Critical path scoring, BFS impact analysis, data lineage, change history, 4 layout modes, shareable links.', status: 'New', cls: 'gold', borderColor: 'rgba(200,160,48,.3)' },
            { icon: '\u25C8', name: 'MATR Analytics', desc: 'Event flow rates, suggestion click heatmaps, feature adoption metrics, and anomaly detection — all in one intelligence dashboard. Auto-refreshes every 30 seconds.', status: 'MATR', cls: 'live', borderColor: 'rgba(10,191,163,.3)' },
            { icon: '\u229E', name: 'Anomaly Detection', desc: 'MATR monitors 7-day rolling baselines across every feature. Automatically surfaces volume drops, pattern breaks, schema drift spikes, and intent shifts before they become incidents.', status: 'MATR', cls: 'live', borderColor: 'rgba(10,191,163,.3)' },
            { icon: '\u2B25', name: 'Query Suggestions', desc: "Context-aware suggestions from connected APIs. Cross-system pairs highlighted in purple — MATR identifies the highest-value queries you haven't asked yet.", status: 'MATR', cls: 'purple' },
            { icon: '\u229F', name: 'Retention & Reporting API', desc: "Configurable retention store for all integration events, query results, and payloads. REST Reporting API lets Databricks, Snowflake, Tableau, and Power BI connect to KOVA as a live data source.", status: 'Live', cls: 'live', borderColor: 'rgba(10,191,163,.3)' },
          ].map((f, i) => (
            <div key={i} className="feat-card">
              <div className="feat-icon-wrap" style={f.borderColor ? { borderColor: f.borderColor } : undefined}>{f.icon}</div>
              <div className="feat-name">{f.name}</div>
              <div className="feat-desc">{f.desc}</div>
              <span className={`feat-status ${f.cls}`}>{f.status}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ─── PROOF STRIP ─── */}
      <div className="proof-strip" data-testid="landing-proof">
        <div className="proof-cell"><div className="proof-val">60s</div><div className="proof-lbl"><strong>First connection</strong>From signup to a live API connection in under 60 seconds.</div></div>
        <div className="proof-cell"><div className="proof-val">0</div><div className="proof-lbl"><strong>Lines of code required</strong>Non-technical operators configure and deploy real integrations.</div></div>
        <div className="proof-cell"><div className="proof-val">3</div><div className="proof-lbl"><strong>LLMs auto-routed</strong>Claude Sonnet 4.6, GPT, and Gemini. Best model for every query.</div></div>
        <div className="proof-cell"><div className="proof-val">&#9672;</div><div className="proof-lbl"><strong>MATR compounds</strong>Every integration event feeds the intelligence layer. It gets smarter every day.</div></div>
      </div>

      {/* ─── CTA ─── */}
      <section className="cta-section" data-testid="landing-cta">
        <div className="cta-diamond cta-d1" />
        <div className="cta-diamond cta-d2" />
        <div className="cta-diamond cta-d3" />
        <div className="cta-inner">
          <h2 className="cta-title">Your integrations<br />have a <em>map now.</em></h2>
          <p className="cta-sub">Connect your first API in 60 seconds. The topology builds itself. The intelligence compounds from day one.</p>
          <div className="cta-btns">
            <button className="btn-primary" onClick={handleGetStarted} data-testid="cta-get-started-btn">Start free at kovahub.co &rarr;</button>
            <button className="btn-ghost">Schedule a demo</button>
          </div>
        </div>
      </section>

      {/* ─── FOOTER ─── */}
      <footer className="lp-footer" data-testid="landing-footer">
        <div>
          <div className="footer-brand">KO<span>VA</span></div>
          <div className="footer-sub">API Intelligence Hub · MERA Technology</div>
        </div>
        <div className="footer-mark">&#9670;</div>
        <div className="footer-links">
          <a href="https://getuday.com">Uday</a>
          <a href="#platform">Cortex</a>
          <a href="#features">PTRN</a>
          <a href="#matr">MATR</a>
          <a href="#mapper">Vernai</a>
        </div>
      </footer>
    </div>
  );
}
